define('lq/services/mpa/applicationValidation',[
    'lq',
    'lq/frontendModules',
    'lq/validatorGateway',
], function (lq, FrontendModules, validatorGateway) {
    'use strict';

    var delta = 500;
    var numberToTrigger = 3;

    function ApplicationValidation(annotations) {
        this.annotations = annotations;
        this.presses = 0;
    };

    ApplicationValidation.typeName = 'ApplicationValidation';

    ApplicationValidation.prototype.initialize = function () {
        if (this.annotations.isProductionModeEnabled) {
            this.handler = this.handleKeyUp.bind(this);
            $(document).on('keyup', this.handler);
        }
    };

    ApplicationValidation.prototype.handleKeyUp = function (event) {
        if (event.keyCode !== 27)
            return;

        var keyPressTime = new Date();

        if (this.previousKeyPressTime && keyPressTime - this.previousKeyPressTime > delta) {
            this.presses = 1;
            this.previousKeyPressTime = keyPressTime;
        } else if (this.presses === numberToTrigger - 1) {
            this.presses = 0;
            this.previousKeyPressTime = null;
            this.loadValidator();
            $(document).off('keyup', this.handler);
        } else {
            this.presses++;
            this.previousKeyPressTime = keyPressTime;
        }
    };

    ApplicationValidation.prototype.loadValidator = function () {
        var self = this;
        FrontendModules.load('validator', true)
            .then(function (Validator) {
                self.start(Validator);
            });
    };

    ApplicationValidation.prototype.start = function (Validator) {
        var validatorConfig = {
            currentTenant: lq.getTenantName(),
            currentApplication: lq.getTenantApplicationName(),
            designerBaseUrl: lq.getDesignerBaseUrl(''),
            cdnUrl: lq.getCdnUrl(''),
            loginUrl: '/Licquid.Designer/Account/Validator',
            frontEndUrl: lq.getFrontEndUrl(''),
            designUrl: lq.getDesignerUrl(''),
            portalUrl: lq.getPortalUrl('')
        };

        Validator.default(validatorConfig, document.getElementById("licquid-validator"));

        validatorGateway.callCallbacks();
    };

    return ApplicationValidation;
});
